import React, { Component } from 'react'
import PakUploadLayout from './PakUploadLayout'
import _ from 'lodash'
import api from '../../../lib/Api'

export default class PakUploadContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      file: null,
      fileName: '',
      uploadResults: null,
      isLoading: false,
      error: null,
    }
  }

  onFileChange = event => {
    const file = event.target.files[0]
    this.setState({
      file: file,
      fileName: file ? file.name : '',
    })
  }

  handleUpload = async () => {
    const bodyFormData = new FormData()
    bodyFormData.set('file', this.state.file)
    this.setState({ isLoading: true })
    try {
      const response = await api.post('pak', bodyFormData)
      this.setState({
        uploadResults: response.data,
        isLoading: false,
        error: null,
        file: null,
      })
    } catch (error) {
      console.error(error)
      const errorMsg =
        error.response && error.response.status === 400
          ? "There's something wrong with the Excel document's format. Please correct any errors in the submitted document or select a properly formatted document and try again."
          : "Something's gone wrong while uploading your PAKs. Please try again or file a ticket for assistance."

      this.setState({
        uploadResults: null,
        isLoading: false,
        error: errorMsg,
        file: null,
      })
    }
  }

  render = () => {
    return (
      <PakUploadLayout
        {...this.state}
        {...this.props}
        handleUpload={this.handleUpload}
        onFileChange={this.onFileChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/pakUpload/PakUploadContainer.js